import { createContext } from "react"

export const CartContext = createContext()

export default CartContext
